import { render, staticRenderFns } from "./StatsData.vue?vue&type=template&id=0df48706&scoped=true&"
import script from "./StatsData.vue?vue&type=script&lang=ts&"
export * from "./StatsData.vue?vue&type=script&lang=ts&"
import style0 from "./StatsData.vue?vue&type=style&index=0&id=0df48706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df48706",
  null
  
)

export default component.exports